import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { translate } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import Crumb, { CrumbTemplateProps } from '../Crumb';

export default function BarcodeSettingsCrumb({ current }: CrumbTemplateProps) {
  return (
    <Crumb
      current={current}
      text={translate({ key: TranslationKey.barcodeExportConfiguration, count: 'plural' })}
      path={Routing.settings.barcodes.overview()}
    />
  );
}
